export default (obj, prop) => obj.map(data => {
  let copy = {...data}
  delete copy[prop]
  return copy
})